module.exports = __webpack_public_path__ + "static/media/logout-icon-white.59451e9d.svg";